import { AuthService } from '@auth0/auth0-angular';
import { inject } from '@angular/core';
import type { Observable } from 'rxjs';

export function login(authService?: AuthService): Observable<void> {
  if (authService === undefined) {
    authService = inject(AuthService);
  }

  return authService.loginWithRedirect({
    appState: { target: '/profile' },
  });
}
